export default class AdminAulaLista {

    /**
     *
     * @param {number} data.anho
     * @param {string} data.empresaId
     * @param {string} data.empresaNombre
     * @param {Array} data.docentes
     * @param {Array} data.secciones
     * @param {Array} data.grados
     */
    constructor(data) {
        const myself = this;
        $('#btn-nueva-aula').click(function() {
            let form = new AdminAulaForm(data);
            form.nuevo({
                onSuccess: function() {
                    window.location.reload();
                }
            });
        });

        $('.btn-editar').click(function() {
            let form = new AdminAulaForm(data);
            form.editar(this.parentNode.dataset.id, {
                onSuccess: function(response) {
                    window.location.reload();
                }
            });
        });

        $('#btn-importar').click(function() {
            let form = new AdminAulaImportarForm(data);
            form.nuevo({
                onSuccess: function(res) {
                    window.location.reload();
                }
            });
        });

        $('#btn-nuevo-docente').click(function() {
            let form = new AdminDocenteForm({empresaId: data.empresaId, empresaNombre: data.empresaNombre});
            form.nuevo({
                onSuccess: function() {
                    $.notify('Docente agregado', 'success');
                    window.location.reload();
                }
            });
        });

        $('#mostrar-aulas').click(function(e) {
            const tam = document.querySelectorAll('#lista-aulas tbody tr').length;
            const mostrar = this.checked ? '1' : '0';
            if (this.checked) {
                if (tam > 0) {
                    myself.__updateConf(this, data, mostrar);
                } else {
                    e.preventDefault();
                    $.notify('Debe tener aulas registradas', 'warning');
                }
            } else {
                myself.__updateConf(this, data, mostrar);
            }
        });
    }

    __updateConf(chk, data, mostrar) {
        chk.disabled = true;
        Ajax.put(`/api/admin/empresas/${data.empresaId}/configuraciones/${data.anho}`, {'mostrar_aulas': mostrar}, {
            then: function(response) {
                if (response.status == 200) {
                    $.notify('Registro exitoso', 'success');
                }
            },
            fail: function(err) {
                console.log(err);
                $.notify('Hubo un error, pruebe nuevamente', 'danger');
            },
            always: function() {
                chk.disabled = false;
            }
        });
    }
}
